export default "__VITE_ASSET__DeFJFmgD__"